import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "../GenericTableResponse";

export class OrderToMerge {
  @IsString()
  @Expose()
  id!: string;
  @IsString()
  @Expose()
  createdAt!: string;
  @IsString()
  @Expose()
  saleDate!: string;
  @IsNumber()
  @Expose()
  gross!: number;
  @IsString()
  @Expose()
  currency!: string;
  @IsNumber()
  @Expose()
  amountOfItems!: number;
  @IsString()
  @Expose()
  comment!: string;
  @IsBoolean()
  @Expose()
  isTemporary!: boolean;
}

export class OrderToMergeResponse extends GenericTableResponse<OrderToMerge> {
  @Type(() => OrderToMerge)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items: Array<OrderToMerge>;
}
